import StringerCollection from "@/packages/stringer/src/StringerCollection";

export default class Stringer {
	value = "";

	constructor(string) {
		this.value = string;
		return this;
	}

	ucSplit() {
		return new StringerCollection(
			this.ucFirst().value.split(/(?<![A-Z])(?=[A-Z])/),
		);
	}

	// camelCase
	camel() {
		this.value = this.studly().lcFirst().value;
		return this;
	}

	// kebab-case
	kebab() {
		this.value = this.words().join("-").value;
		return this;
	}

	// StudlyCase
	studly() {
		this.value = this.words().map("ucFirst").join("").value;
		return this;
	}

	// PascalCase
	pascal() {
		this.studly();
		return this;
	}

	// snake_case
	snake() {
		this.value = this.words().join("_").value;
		return this;
	}

	trim() {
		this.value = this.value.trim();
		return this;
	}

	words() {
		return this.ucSplit().map(stringer => {
			return stringer
				.replace(/[-_\s{2,}]/g, " ")
				.trim().lower().value;
		}).join(" ").split(" ");
	}

	ucWords() {
		return this.words().map("ucFirst");
	}

	lcFirst() {
		this.value = this.value.charAt(0).toLowerCase() + this.value.slice(1);
		return this;
	}

	lower() {
		this.value = this.value.toLowerCase();
		return this;
	}

	ucFirst() {
		this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);
		return this;
	}

	upper() {
		this.value = this.value.toUpperCase();
		return this;
	}

	replace(search, value = "") {
		this.value = this.value.replace(search, value);
		return this;
	}

	lTrim(search) {
		return this.replaceStart(search, "");
	}

	replaceStart(search, value = "") {
		if (!this.startsWith(search)) {
			return this;
		}
		const regexp = new RegExp(`^(${search})`);
		this.value = this.value.replace(regexp, value);
		return this;
	}

	replaceEnd(search, value = "") {
		if (!this.endsWith(search)) {
			return this;
		}
		const regexp = new RegExp(`(${search})$`);
		this.value = this.value.replace(regexp, value);
		return this;
	}

	startsWith(search) {
		const regexp = new RegExp(`^(${search})`);
		return regexp.test(this.value);
	}

	endsWith(search) {
		const regexp = new RegExp(`(${search})$`);
		return regexp.test(this.value);
	}

	replaceArray(search, values = []) {
		for (let i in values) {
			this.replace(search, values[i]);
		}
		return this;
	}

	slice(start, end) {
		this.value = this.value.slice(start, end);
		return this;
	}

	contains(value) {
		return this.value.search(value) > -1;
	}

	nGetText(singular, plural, count) {
		let message = new this.constructor(count === 1 ? singular : plural).replace("#", count).value;
		return this.replace("#", count).replace("?", message);
	}

	split(value) {
		return new StringerCollection(this.value.split(value));
	}

	map(callback, key) {
		let value = callback(this, key);
		this.value = value instanceof Stringer ? value.value : value;
		return this;
	}

	append(value) {
		this.value = this.value + value;
		return this;
	}
}
